var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"width":"179px","height":"243px"},attrs:{"alt":"Logo Provincie Vlaams-Brabant","src":"/img/Logo.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }